<template>
  <v-container class="main" fluid>
    <CardCounts/>
    <v-row class="pa-2" v-if="showGraph">
      <v-col>
        <v-card flat>
          <v-card-title></v-card-title>
          <v-card-text>
            <vue-highcharts :options="options" :className="className" ref="colunmChart"></vue-highcharts>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
// import { AdminUserPermissions } from "../../utils/user-role";
import CardCounts from "../components/dashboard/CardCounts.vue"
import VueHighcharts from '../components/dashboard/VueHighcharts.vue'
// import Highcharts from 'highcharts'
export default {
  components: {
    CardCounts,
    VueHighcharts
  },
  data () {
    return {
      grapData: [],
      showGraph: false,
      className: 'custom-css-vue-charts'
    }
  },
  methods:{

  },
  computed: {
    options () {
      return {
        chart: {
        type: 'column',
        spacingBottom: 15,
        spacingTop: 10,
        spacingLeft: 10,
        spacingRight: 10,
        height: null
      },
      title: {
        text: this.$t('dashboard.rentingCount'),
        style: { "color": "#333333", "fontSize": "20px" }
      },
      subtitle: {
        // text:
          // 'Source: <a href="https://en.wikipedia.org/wiki/World_population">Wikipedia.org</a>',
      },
      xAxis: {
        categories: [
          this.$t('dashboard.jan'),
          this.$t('dashboard.feb'),
          this.$t('dashboard.mar'),
          this.$t('dashboard.apr'),
          this.$t('dashboard.may'),
          this.$t('dashboard.june'),
          this.$t('dashboard.july'),
          this.$t('dashboard.aug'),
          this.$t('dashboard.sep'),
          this.$t('dashboard.oct'),
          this.$t('dashboard.nov'),
          this.$t('dashboard.dec')
        ],
        crosshair: true,
        title: {
          text: this.$t('dashboard.revenue'),
          align: 'high'
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: null,
        },
        labels: {
          overflow: 'justify',
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat: `<tr><td style="color:{series.color};padding:0">{series.name}: </td>
            <td style="padding:0"><b>{point.y} ${this.$t("dashboard.renting")}</b></td></tr>`,
        footerFormat: '</table>',
        shared: true,
        useHTML: true
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0
        }
      },
      // legend: {
      //   layout: 'vertical',
      //   align: 'right',
      //   verticalAlign: 'top',
      //   x: -70,
      //   y: 40,
      //   floating: true,
      //   borderWidth: 1,
      //   backgroundColor:
      //     (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF',
      //   shadow: true,
      // },
      credits: {
        enabled: false,
      },
      series: [],
      }
    }
  },
  mounted() {
    //
  },
  beforeDestroy() {
    //
  },
  apollo: {
    getGraphValues() {
      return {
        query: require("@/user/api/queries/graph_query.graphql"),
        variables: {
          searchKey: ''
        },
        result({ data }) {
          // , loading, networkStatus, refetch
          this.grapData = this.$format.cloneVariable(data.getGraphValues.yearMonthPrice)
          let uniqYear = [
            ...new Set(
            this.grapData.map(x=> x.year).sort((a, b) =>  a - b)
            )
          ]
          uniqYear.forEach(year =>
          this.options.series.push(
            { name: year, data: [null, null, null, null, null, null, null, null, null, null, null, null] }
          ))
          this.options.series.forEach(series => {
            this.grapData.filter(x => {
              if (x.year === series.name)
                series.data[x.month - 1] = x.totalPriceMonth
            })
          })
          this.showGraph = true
        }
      };
    }
  },
}
</script>
<style>
</style>
